import { render, staticRenderFns } from "./CmgLeaderboardEducationCardModal.vue?vue&type=template&id=6d59f0e2&scoped=true&lang=pug"
import script from "./cmg-leaderboard-education-card-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-education-card-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardEducationCardModal.vue?vue&type=style&index=0&id=6d59f0e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d59f0e2",
  null
  
)

export default component.exports